export const calcExpectedROAS = (value: string | number): number => {
  const expectedCOS = Number(String(value || 0).replace(',', '.'))
  return expectedCOS > 0 ? Math.round(10000 / expectedCOS) : 0
}

export const calcExpectedCOS = (value: string | number): number => {
  const expectedROAS = Number(String(value || 0).replace(',', '.'))
  return expectedROAS > 0 ? Number((10000 / expectedROAS).toFixed(2)) : 0
}
